import { AccordionSummary, Box, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FormattedMessage, useIntl } from "react-intl";

import { TooltipLabel } from "../../components/Tooltips";
import { LanguagesType } from "../interfaces";
import { MAX_CHARACTERS } from "../utils";

const EditorAccordionSummary = ({
  charCount,
  editorErrors,
  errorFilledMsg,
  lang,
}: {
  charCount: number;
  editorErrors?: string[];
  errorFilledMsg?: string;
  lang: LanguagesType;
}) => {
  const intl = useIntl();

  return (
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Box sx={{ display: "flex", gap: 1.5, alignItems: "baseline" }}>
        <Typography
          component={"h2"}
          sx={{
            color:
              errorFilledMsg || (editorErrors && editorErrors.length > 0)
                ? "error.main"
                : "text.primary",
          }}
        >
          <FormattedMessage id={lang.value} />
        </Typography>
        <Typography
          sx={{
            color:
              errorFilledMsg || (editorErrors && editorErrors.length > 0)
                ? "error.main"
                : "text.primary",
            fontSize: "0.75rem",
          }}
          component={"span"}
        >
          {charCount} / {MAX_CHARACTERS}
        </Typography>
        {errorFilledMsg && (
          <Typography
            sx={{
              color: "error.main",
              fontSize: "0.75rem",
            }}
            component={"span"}
          >
            <FormattedMessage id={errorFilledMsg} />
          </Typography>
        )}
        {editorErrors && editorErrors.length > 0 && (
          <>
            {editorErrors.length === 1 && (
              <Typography
                sx={{
                  color: "error.main",
                  fontSize: "0.75rem",
                }}
                component={"span"}
              >
                <FormattedMessage id={editorErrors[0]} />
              </Typography>
            )}
            {editorErrors.length > 1 && (
              <TooltipLabel
                translateTooltip={false}
                label={intl.formatMessage({
                  id: "BANNER_MULTIPLE_ERRORS_TOOLTIP",
                })}
                sxStyles={{ color: "error.main", fontSize: "0.75rem" }}
                tooltipLabel={
                  <ul
                    style={{
                      margin: 0,
                      padding: "0 0 0 16px",
                    }}
                  >
                    {editorErrors.map((errors) => (
                      <li key={errors}>
                        <Typography
                          sx={{
                            color: "error.main",
                            fontSize: "0.75rem",
                          }}
                          component={"span"}
                        >
                          <FormattedMessage id={errors} />
                        </Typography>
                      </li>
                    ))}
                  </ul>
                }
              />
            )}
          </>
        )}
      </Box>
    </AccordionSummary>
  );
};

export default EditorAccordionSummary;
